<!-- 合作伙伴 -->
<template>
<div v-if="isPc">
    <el-row :gutter="20" type="flex" justify="center" v-for="index in 4" :key="index" :class="index==1? '': 'mt20'">
        <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4" v-for="(item, i) in partnerList.slice((index-1)*4,index*4)" :key="i" >
          <div>
            <el-image
              :src="require(`@/assets/images/partners/${item}.jpg`)"
              class="icon-image image-transition-scale2">
            </el-image>
          </div>
        </el-col>
      </el-row>
</div>
<div v-else>
   <el-row :gutter="20"   justify="center" v-for="index in 4" :key="index" :class="index==1? '': 'mt20'">
        <el-col :span="6" v-for="(item, i) in partnerList.slice((index-1)*4,index*4)" :key="i"  align="center">
          <div class="div-partner-icon-image">
             <el-image
              :src="require(`@/assets/images/partners/${item}.jpg`)"
              class="partner-icon-image image-transition-scale2">
            </el-image>  
          </div>
        </el-col>
     </el-row>
</div>
</template> 

<script>
export default {
   name:"Partner",
   data(){
    return {
      isPc:true,
      partnerList: ["partner1", "partner2", "partner3", "partner4","partner5", "partner6","partner7","partner8","partner9","partner10","partner11","partner12","partner13","partner14","partner15","partner16"]// 关于图标
    }
   },
   created(){
      this.isPc = this.$store.state.isPc;
   }
}
</script>>

<style scoped>
@import "../../style/main.css";

 
 .div-partner-icon-image {  /*手机端样式*/
  height: 40px;
  width: 100%;
  overflow: hidden;
  /* border: 1px solid #f4f4f6;  
   border-radius: 5px;   */
  padding: 20px 0 10px 0;
  /* box-shadow: 0 6px 20px 0 #d7e8ff;
  background-color: #fff; */
}
.partner-icon-image {
  width: 60px;
  width: 60px;
  /* border-radius: 50%; */
}

.div-partner-icon-image:hover .partner-icon-image  {
  transform: scale(1.3, 1.3);
  color: #000;
}
.div-partner-icon-image:hover {
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.3);
}
</style>>
 